import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import { Close as CloseIcon, FileDownload as FileDownloadIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export interface ExportConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  schoolName: string;
  isLoading?: boolean;
}

const ExportConfirmationModal: React.FC<ExportConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  schoolName,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={isLoading ? undefined : onClose} className="message-modal">
      <IconButton onClick={onClose} disabled={isLoading} className="close-button">
        <CloseIcon />
      </IconButton>

      <DialogTitle component="h3">
        <FileDownloadIcon
          sx={{
            backgroundColor: 'white',
            fontSize: 46,
            border: '6px solid #7B1FA2',
            borderRadius: '50%',
            path: { color: '#7B1FA2' },
            padding: '4px',
          }}
        />
        {t('exportSchoolTitle')}
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center' }}>
        <p>{t('exportSchoolMessage', { schoolName })}</p>
      </DialogContent>

      <DialogActions style={{ marginBottom: 0 }}>
        <Button onClick={onClose} variant="outlined" disabled={isLoading} className="cancel-button">
          {t('cancel')}
        </Button>
        <Button
          onClick={isLoading ? undefined : onConfirm}
          variant="contained"
          sx={{
            backgroundColor: '#7B1FA2 !important',
            color: 'white !important',
            '&:hover': { backgroundColor: isLoading ? '#7B1FA2 !important' : '#6A1B9A !important' },
            minWidth: 120,
            pointerEvents: isLoading ? 'none' : 'auto',
            display: 'flex',
            gap: 1,
          }}
        >
          {isLoading ? (
            <>
              <CircularProgress size={20} sx={{ color: 'white' }} />
              {t('exporting')}
            </>
          ) : (
            <>
              <FileDownloadIcon />
              {t('exportSchoolButton')}
            </>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportConfirmationModal;
